import { formatBoolean, formatDate, toCamelCase } from "@compass/core";
import { CustomDataModelField, LkCustomDataModelFieldTypeId } from "generated/openApi";

export const CustomDataModelFieldDisplay = (props: { field: CustomDataModelField; dataModel: any }) => {
  const fieldName = toCamelCase(props.field.fieldName)!;
  const selectListName = toCamelCase(props.field.selectListName)!;

  return (
    <>
      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.TextNumber) && props.dataModel?.[fieldName]}
      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.NullableBool) &&
        formatBoolean(props.dataModel?.[fieldName])}
      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.Date) &&
        formatDate(props.dataModel?.[fieldName])}
      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.SelectList) &&
        props.dataModel?.[selectListName]?.name}
    </>
  );
};
